<template>
  <div class="tabs">
    <button
      v-for="tab in tabsItems"
      :key="tab.id"
      class="tabs__item"
      :class="{
        'tabs__item--active': tab.isActive,
      }"
      @click="toggleTab(tab)"
    >
      {{ tab.title }}
    </button>
  </div>
</template>

<script>
  export default {
    name: 'CallLogsTabs',
    data() {
      return {
        activeTabId: 1,
      };
    },
    computed: {
      tabsItems() {
        return [
          {
            id: 1,
            title: this.$t('call_center.call_log_category.all'),
            value: 'all',
            isActive: false,
          },
          {
            id: 2,
            title: this.$t('call_center.call_log_category.incoming'),
            value: 'inbound',
            isActive: false,
          },
          {
            id: 3,
            title: this.$t('call_center.call_log_category.outgoing'),
            value: 'outbound',
            isActive: false,
          },
          {
            id: 4,
            title: this.$t('call_center.call_log_category.missed'),
            value: 'missed',
            isActive: false,
          },
        ].map((tab) => {
          return {
            ...tab,
            isActive: tab.id == this.activeTabId,
          };
        });
      },
    },
    methods: {
      async toggleTab(tab) {
        this.activeTabId = tab.id;
        this.$emit('tab-changed', tab.value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tabs {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    margin-block: 8px 24px;
    &__item {
      flex: 1 0 0;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      padding: 8px 10px;
      border-radius: 8px;
      border: 1px solid var(--gray100);
      color: var(--gray500);
      background-color: var(--shadesWhite);
      transition: all 300ms ease-in-out;
      &--active {
        font-size: 12px;
        color: var(--color-base-500);
        border-color: var(--color-base-500);
        background-color: var(--color-base-50);
      }
    }
  }
</style>
